module.exports = __webpack_public_path__ + "static/media/MOJI-101-badge.3fc88a19.svg";